/* Повторяющийся платёж проекта (ТЗ 5.11) — отдельная страница, как все формы.
   /schedule/:id, где id — проект. Одно расписание на проект, сервер апсертит. */

import { Button, List, ListButton, ListInput } from "konsta/react";
import React, { useState } from "react";
import { useNavigate, useParams } from "../lib/router.jsx";

import Screen from "../components/Screen.jsx";
import { SkelForm } from "../components/skeleton.jsx";
import { ErrorState, MoneyInput } from "../components/ui.jsx";
import { api } from "../lib/api.js";
import { useApp, useFetch } from "../lib/store.jsx";
import { haptic } from "../lib/tg.js";

export default function ScheduleEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { reloadAlerts } = useApp();
  const { data: p, loading, error, refetch } = useFetch(`/projects/${id}`);

  const [f, setF] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  // Форма заполняется один раз, когда проект приехал
  React.useEffect(() => {
    if (f || !p) return;
    const s = p.schedule;
    setF({
      /* У подписки сумма почти всегда равна MRR сделки — подставляем её,
         чтобы не перенабирать; день и тип человек выбирает сам */
      amount: s?.amount ?? p.dealMrr ?? "",
      day: s?.day != null ? String(s.day) : "",
      kind: s?.kind ?? "",
    });
  }, [f, p]);

  if (loading || !f) return <Screen back title="Повторяющийся платёж"><SkelForm /></Screen>;
  if (error) return <Screen back><ErrorState text={error} onRetry={refetch} /></Screen>;

  const set = (k) => (e) => setF((prev) => ({ ...prev, [k]: e.target.value }));

  const save = async () => {
    const problem = !(Number(f.amount) > 0) ? "Укажите сумму больше нуля"
      : !f.day ? "Выберите число месяца"
        : null;
    if (problem) return setErr(problem);
    setBusy(true);
    setErr(null);
    try {
      await api.post("/schedules", {
        project: id,
        dealId: p.dealId,
        amount: Number(f.amount) || 0,
        day: Number(f.day) || 1,
        active: true,
        kind: f.kind || null,
      });
      haptic.success();
      reloadAlerts();
      navigate(-1);
    } catch (e) {
      haptic.error();
      setErr(e.message);
      setBusy(false);
    }
  };

  const disable = async () => {
    setBusy(true);
    try {
      await api.patch(`/schedules/${p.schedule.id}`, { active: false });
      haptic.success();
      reloadAlerts();
      navigate(-1);
    } catch (e) {
      haptic.error();
      setErr(e.message);
      setBusy(false);
    }
  };

  return (
    <Screen back title="Повторяющийся платёж">
      <List strong inset>
        <MoneyInput placeholder="Сумма, ₽" value={f.amount} onChange={set("amount")} />
        {/* Подпись селекта зашита в варианты — placeholder в select не виден */}
        <ListInput type="select" dropdown value={f.day} onChange={set("day")}>
          <option value="">Число месяца не выбрано</option>
          {Array.from({ length: 31 }, (_, i) => i + 1).map((n) => (
            <option key={n} value={n}>Платёж · {n}-го числа</option>
          ))}
        </ListInput>
        <ListInput type="text" placeholder="Тип · подписка, аренда" value={f.kind} onChange={set("kind")} />
      </List>

      {err ? (
        <div className="px-4 pt-1 text-center text-[13px]" style={{ color: "var(--fin-red)" }}>{err}</div>
      ) : null}

      <div className="px-4 pt-3">
        <Button large rounded onClick={save} disabled={busy}>
          {p.schedule?.active ? "Сохранить" : "Включить"}
        </Button>
      </div>

      {p.schedule?.active ? (
        <List strong inset>
          <ListButton colors={{ textIos: "text-[color:var(--fin-red)]" }} onClick={disable}>
            Выключить
          </ListButton>
        </List>
      ) : null}
    </Screen>
  );
}
